import { Island } from '../island.class';

export const isCornerIslandCfn = (island: Island): boolean => {
	// use island connections and position to determin if its a corner island
	return island.panels.children.length === 5;
};
